import Loader from '../../_media/loaders/loader.gif';
import '../CSS/private/Loaders.css';

function PageLoader() {
  return (
    <div className='slp-pageloader'>
      <img src={Loader} width='100px' alt='loading bars' />
    </div>
  )
}

export default PageLoader;